import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


interface MobileCode {
  code: string;
  fieldkey: string;
}

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  prefixArray:any = [];
  private country_prefix = new BehaviorSubject<MobileCode[]>([]);
  prefix = this.country_prefix.asObservable();

  constructor() { }

  getCountryCode = (fieldKey: string): string | undefined => {
    const mobileCode = this.country_prefix.value
      .find( (key) => key.fieldkey === fieldKey);
    return mobileCode?.code;
  }

  _setCountryPrefix = (prefix) =>{
    this.country_prefix.next(prefix);
  }
}
